
import { Button, Drawer, Modal, Menu, Dropdown, message } from "antd"
import {DownOutlined} from '@ant-design/icons'
import CanWrapper from "../../../../../components/Can"
import axios from 'axios'
import { useState } from "react"
import BulkUsers from "./components/bulkUsers"
import BulkWatchers from "./components/bulkWatchers"
import BulkAddToList from "./components/bulkList"
export default function BulkEdit(props){
    const {ids, reload, setReload, pagination} = props
    const [open, setOpen] = useState(false)
    const menu = <Menu style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
        <CanWrapper perms={["can_save_ticket"]}>
            <Menu.Item style={{padding: 0, background: 'white'}} key="1">
                <BulkUsers setReload={setReload} reload={reload} tickets={ids}></BulkUsers>
            </Menu.Item>
            <Menu.Item style={{padding: 0, background: 'white'}} key="2">
                <BulkWatchers setReload={setReload} reload={reload} tickets={ids}></BulkWatchers>
            </Menu.Item>            
        </CanWrapper>
        <Menu.Item style={{padding: 0, background: 'white'}} key="2">
            <BulkAddToList setReload={setReload} reload={reload} tickets={ids}></BulkAddToList>
        </Menu.Item>
        {pagination?.list && pagination.list !== 'none' && ids.length > 0 &&  (
            <Menu.Item style={{padding: 0, background: 'white'}} key="3">
                <Button 
                    type="primary" 
                    danger
                    onClick={async () => {
                        try {
                            await axios.post(`/sprawy/lists/tickets/delete`, {
                                listid: pagination.list,
                                tickets: ids
                            })
                            message.success('Sprawy zostały usunięte z listy')
                            setReload(!reload)
                        } catch (error) {
                            message.error('Wystąpił błąd podczas usuwania spraw z listy')
                        }
                    }}
                    style={{width: '100%'}}
                >
                    Usuń z listy
                </Button>
            </Menu.Item>
        )}
    </Menu>

    return <>
    
    {ids.length > 0 ? <>
        <Dropdown overlay={menu} trigger={["click"]} onOpenChange={(flag) => setOpen(flag)} open={open}>
            <Button>
                Akcje hurtowe <DownOutlined />
            </Button>
        </Dropdown>
    </> : <></>}
    </>
}